export default class ProcessedFile {
	public fileName: string;
	public fileType: string;
	public fileSizeInBytes: number;
	public binaryFile: ArrayBuffer; 

	public constructor(fileName: string, fileType: string, fileSizeInBytes: number, binaryFile: ArrayBuffer) {
		this.fileName = fileName;
		this.fileType = fileType;
		this.fileSizeInBytes = fileSizeInBytes;
		this.binaryFile = binaryFile;
	}
}